export function buildInitialsProfile(profileData) {
    const { firstName = '', lastName } = profileData;
    const firstInitial = firstName ? firstName.trim().charAt(0) : '';
    const secondInitial = lastName ? lastName.trim().charAt(0) : '';
    return `${firstInitial}${secondInitial}`.toUpperCase();
}
export const getInRiverIds = (setIds, items) => {
    items?.childPages?.forEach((item) => {
        if (item.inRiverId) {
            setIds((prev) => (item.inRiverId ? [...prev, item.inRiverId] : prev));
        }
        else {
            getInRiverIds(setIds, item);
        }
    });
};
// Helper for AEM component
export const isEmptyHeader = (props) => !props?.logoLink;
